import Vue from 'vue'
import VueRouter from 'vue-router'
import authenticate from '@/middleware/authenticate.js'

import HomeLayout from '@/layouts/home.vue'
import Home from '@/pages/home.vue'
import Product from '@/pages/_product.vue'
import Contact from '@/pages/Contact.vue'
import CategoryProducts from '@/pages/CategoryProducts.vue'

import PortalLayout from '@/layouts/portal.vue'
import PortalProducts from '@/pages/portal/products.vue'
import PortalCategories from '@/pages/portal/categories.vue'
import CreateOrUpdateProduct from '@/pages/portal/createOrUpdateProduct.vue'
import CreateCategory from '@/components/ui/portal/CreateCategory.vue'

import AuthLogin from '@/pages/auth/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: HomeLayout,
    redirect: { name: 'Home' },
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home
      },
      {
        path: '/product/:id',
        name: 'Product',
        component: Product
      },
      {
        path: '/category/:id',
        name: 'CategoryProducts',
        component: CategoryProducts
      },
      {
        path: '/contact',
        name: 'Contact',
        component: Contact
      },
      {
        path: '/imprint',
        name: 'Imprint',
        component: () =>
          import(/* webpackChunkName: "imprint" */ '@/pages/Imprint.vue')
      },
      {
        path: '/data-protection',
        name: 'Data',
        component: () =>
          import(/* webpackChunkName: "data" */ '@/pages/DataProtection.vue')
      }
    ]
  },
  {
    path: '/auth',
    component: AuthLogin,
    name: 'Auth'
  },
  {
    path: '/portal',
    beforeEnter: authenticate,
    name: 'Portal',
    component: PortalLayout,
    children: [
      {
        path: '/categories',
        name: 'PortalCategories',
        component: PortalCategories
      },
      {
        path: '/products',
        name: 'PortalProducts',
        component: PortalProducts
      },
      {
        path: '/products/cu/:id?',
        name: 'CreateOrUpdateProduct',
        component: CreateOrUpdateProduct
      },
      {
        path: '/categories/cu',
        name: 'CreateCategory',
        component: CreateCategory
      }
    ]
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '@/pages/404.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
